// Utility for truncating and formatting numbers with commas and fixed decimal places

/**
 * Truncate a number to a fixed number of decimal places (no rounding).
 * @param {number|string} value - The number to truncate.
 * @param {number} decimals - Number of decimal places (default 4).
 * @returns {number}
 */
export function truncateDecimals(value, decimals = 4) {
  if (value === null || value === undefined || value === '') return '';
  const num = Number(value);
  if (isNaN(num)) return '';
  const factor = Math.pow(10, decimals);
  return Math.trunc(num * factor) / factor;
}

/**
 * Format a number with commas and exactly N decimals, using truncation (not rounding).
 * @param {number|string} value - The number to format.
 * @param {number} decimals - Number of decimal places (default 4).
 * @returns {string}
 */
export function formatNumberWithCommas(value, decimals = 4) {
  if (value === null || value === undefined || value === '') return 'N/A';
  const truncated = truncateDecimals(value, decimals);
  // Ensure exactly N decimals (pad with zeros if needed)
  return truncated.toLocaleString(undefined, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
    useGrouping: true
  });
}
